import { useLocalStorage } from 'usehooks-ts'
import { config } from '#services/config'

export type DataViewLocalStorageKey =
  | 'allSources'
  | 'companyDashboard'
  | 'companySources'
  | 'portfolioDashboard'
  | 'portfolioDashboardCardView'
  | 'portfolioDisclosure'
  | 'portfolioSources'
  | 'portfolioComparison'

type Props<Value> = {
  pageKey: DataViewLocalStorageKey
  initialValue: Value
}

export const useUIPrefs = <Value>({ pageKey, initialValue }: Props<Value>) => {
  const [dataView, setDataView] = useLocalStorage(
    `${config.localStorageKeys.dataView}:${pageKey}`,
    initialValue,
  )

  return { dataView, setDataView }
}
